export const headers = [
  { label: "Company", key: "name" },
  // { label: "Pipeline stage", key: "pipelineStage" },
  // { label: "Founders", key: "team" },
  { label: "Founding Year", key: "foundingDate" },
  { label: "Financial stage", key: "financialStage" },
  // { label: "Valuation", key: "valuation" },
  { label: "Total funding", key: "totalFunding" },
  { label: "Investors", key: "investors" },
  { label: "Location", key: "city" },
  { label: "Website", key: "website" }
  // { label: "Notes", key: "notes" }
  // { label: "Actions", key: "actions" }
];

export const sortableHeaders: (string | null)[] = ["name", "financialStage", "totalFunding", "foundingYear", null];
